import { H1, useBreadcrumbs } from "@inmagik/magik-ui"
import Layout from "../../components/Layout"
import { type Path } from "../../types"
import { useNavigate } from "react-router-dom"
import { Formik } from "formik"
import { Container } from "react-bootstrap"
import BottomFormFixed from "../../components/BottomFormFixed"
import { useMemo } from "react"
import { ScrollLayout } from "../../components/ScrollLayout"
import { initialValuesPath, validationSchemaPath } from "./PathCommon"
import { useCreatePath } from "../../hooks/paths"
import PathForm from "./PathForm"

export default function PathCreate() {
  const createPath = useCreatePath()
  const navigate = useNavigate()

  const initialValues = useMemo(() => initialValuesPath(), [])
  const validationSchema = useMemo(() => validationSchemaPath(), [])
  useBreadcrumbs([{ label: "Percorsi", href: "/paths/paths" }, { label: "Creazione Percorso" }])

  return (
    <Layout>
      <ScrollLayout hasBottomFixed>
        <H1>Nuovo percorso</H1>
        <ScrollLayout.Scroll>
          <Formik
            enableReinitialize
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={(values) => {
              return createPath.mutateAsync(values as Path).then((path) => {
                navigate(`/paths/paths/${path.id}`)
              })
            }}
          >
            {({ handleSubmit }) => (
              <form onSubmit={handleSubmit}>
                <Container fluid className="mt-6" style={{ marginBottom: "100px" }}>
                  <PathForm />
                </Container>
                <BottomFormFixed url="/paths/paths" />
              </form>
            )}
          </Formik>
        </ScrollLayout.Scroll>
      </ScrollLayout>
    </Layout>
  )
}
